var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-flex-c profile-content"},[_c('div',{staticClass:"d-flex profile-button"},[(_vm.currentRouteName === 'Teams')?_c('content-button',{attrs:{"label":"Create team"},on:{"button-click":function($event){return _vm.setActiveProfileModal({
          name: 'CreateTeamModal',
        })}}}):_vm._e()],1),_c('keep-alive',[_c('content-wrapper',{attrs:{"title":`${
        _vm.currentRouteName === 'Settings' ? 'Account' : _vm.currentRouteName
      } Settings`}},[_c('div',{staticStyle:{"height":"100%"},attrs:{"slot":"content"},slot:"content"},[_c(_vm.currentRouteName,{tag:"component"})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }